import { SettingsThresholds } from "@/entities/settings/types";
import { cn } from "@/utils/utils";
import React from "react";

export const validScores = ["low", "medium", "high", "unknown"] as const;
export type ScoreStrength = (typeof validScores)[number];

export const ScoreStrengthFromValue = (
  value: number,
  thresholds: SettingsThresholds | undefined
) =>
  thresholds
    ? value < thresholds.medium
      ? "low"
      : value < thresholds.high
        ? "medium"
        : "high"
    : "unknown";

type Props = {
  score: ScoreStrength;
};

const ScoreBadge: React.FC<Props> = ({ score }) => {
  const strengthToColor: Record<ScoreStrength, string> = {
    low: "charts-negative",
    medium: "charts-warning",
    high: "charts-positive",
    unknown: "border-field-default"
  };
  const numColoredBars: number =
    score !== "unknown" ? validScores.indexOf(score) + 1 : 3;
  const bars = Array.from({ length: 3 }, (_, index) => (
    <span
      key={index}
      className={cn(
        "w-[3px] h-3 mr-0.5 rounded-[18px]",
        index < numColoredBars && index < 4
          ? `bg-${strengthToColor[score]}`
          : "bg-badges-selected"
      )}
    ></span>
  ));

  // Spans, not divs: the bars render inside a tooltip trigger button on an
  // Unknown ICP fit and inside filter option rows, neither of which may contain
  // flow content. inline-flex lays them out identically.
  return (
    <span className="inline-flex items-center">
      <span className="inline-flex">{bars}</span>
    </span>
  );
};

export default ScoreBadge;
